import { useRef, ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import { XButtonForm } from "src/components/common/form/XButtonForm";
import ReactDOM from 'react-dom';
import { DateRange } from "react-day-picker";
import { formatDate } from "src/utils/string/stringUtil";
import DateRangePicker from "src/components/common/calendar/DateRangePicker";
import { searchFormString, searchDateRangeFormString, gridCalendarHeight, gridCalendarWidth, gridCalendarLayoutHeight, searchFieldWidth, searchLabelStyle } from "src/components/common/common";

interface Props {
	label: string;
	titleWidth?: number;
	wrapperOption?: {
		wrapperStyle?: string;
		titleStyle?: string;
		dateRangeStyle?: string;
	}
	visible: boolean;									setVisible: (visible: boolean) => void;
	dateRange: DateRange | undefined,					setDateRange: (dateRange: DateRange | undefined) => void;
	pickerPosition: { top: number; left: number };		setPickerPosition: (pickerPosition: { top: number; left: number }) => void;
}

export const SearchDateRangeForm = ( props: Props ) => {

	const {
		label = "라벨",
		titleWidth,
		wrapperOption = {
			wrapperStyle: searchFieldWidth,
			titleStyle: searchLabelStyle,
			dateRangeStyle: searchDateRangeFormString,
		},
		visible, setVisible,
		dateRange, setDateRange,
		pickerPosition, setPickerPosition,
	} = props;

	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {

		if (visible && inputRef.current) {
			const rect = inputRef.current.getBoundingClientRect();
            const pTagWidth = rect.width;
            const newLeft = rect.left - (pTagWidth / 2) + window.scrollX;
			setPickerPosition({
				top: rect.bottom + window.scrollY,
				left: newLeft, 
			});
		}
	}, [visible]);
	
	return (
		<>
		{/* titleWidth를 전달한 다국어 검색조건만 내용 너비로 확장하고 기존 사용처는 기존 스타일을 유지한다. */}
		<div className={`${ searchFormString } ${ wrapperOption?.wrapperStyle || '' } cursor-pointer`}
			style={titleWidth ? { width: "max-content" } : undefined}
			onClick={() => setVisible(true)}
		>
			<p
				className={wrapperOption?.titleStyle || searchLabelStyle}
				style={titleWidth ? {
					width: titleWidth,
					minWidth: titleWidth,
					whiteSpace: "nowrap",
					overflow: "hidden",
					textOverflow: "ellipsis",
				} : undefined}
				title={label}
			>
				{label}
			</p>
				<div className="relative flex flex-col" style={{ position: 'relative' }}>
					{/* 날짜 선택 영역(클릭 시 달력 팝업) */}
					<p className={`${ wrapperOption?.dateRangeStyle || searchDateRangeFormString } cursor-pointer`}
						onClick={(e) =>{ e.stopPropagation(); setVisible(true) }}
						ref={inputRef}
						title={dateRange?.from ? `${formatDate(dateRange.from)} ~ ${dateRange.to ? formatDate(dateRange.to) : ""}` : "날짜를 선택해주세요."}
						>

						{dateRange?.from
							? `${formatDate(dateRange.from)} ~ ${dateRange.to ? formatDate(dateRange.to) : ""}`
							: "날짜를 선택해주세요."}
					</p>
					{/* 달력 팝업 */}
					{visible &&
						ReactDOM.createPortal(
						<>
							<div
							style={{
								position: 'fixed',
								top: 0,
								left: 0,
								width: gridCalendarWidth,
								height: gridCalendarLayoutHeight,
								zIndex: 9998,
								// backgroundColor: 'rgba(0,0,0,0.1)', // 필요시 반투명 배경 추가
							}}
							onClick={(e) => {
								e.stopPropagation();
								setVisible(false);
							}}
							/>
							<div
								style={{
									position: 'absolute',
									top: `${pickerPosition.top}px`,
									left: `${pickerPosition.left}px`,
									zIndex: 9999, // DateRangePicker z-index
								}}
							>
							<DateRangePicker
								from={dateRange?.from}
								to={dateRange?.to}
								onChange={(range: DateRange) => {
									setDateRange({
										from: range.from,
										to: range.to,
									});
								}}
								onCancel={() => setVisible(false)}
								onConfirm={(range: DateRange) => {
									setDateRange({
										from: range.from,
										to: range.to,
									});
									setVisible(false); // <- 이 함수가 모달을 닫아야 함
								}}
							/>
							</div>
						</>,
						document.body
						)}
				</div>
			</div>
		</>
	)
}
